import "./InputComponent.scss"
const InputComponent = (
    { lableValue,
        inputName,
        inputType,
        inputId,
        inputPlaceholder,
        defaultValue,
        inputWidth,
        onChange,
        errorMessage
    }) => {
    return (
        // <div className="input-box">
        <div className="input-component d-flex flex-column col-12 col-sm-6 col-md-4 col-lg-3">
            <div className="input-box">
                {
                    inputName &&
                    <input
                        style={inputWidth && `width:${inputWidth}; `}
                        type={inputType || "text"}
                        placeholder={inputPlaceholder || null}
                        name={inputName}
                        id={inputId}
                        onChange={onChange}
                        defaultValue={defaultValue}
                        autoComplete="off"
                    />
                }
                {lableValue &&
                    <label
                        htmlFor={inputId}>
                        {lableValue}
                    </label>}
            </div >
            {errorMessage &&
                <div className="Input-component-error-container">
                    <p className="Input-component-error-message">
                        تست پیام خطا
                    </p>
                </div>}
        </div>
    )
}

export default InputComponent